'use strict';

var React = require('react'),
    IconMixin = require('../../mixins/IconMixin');

var LinkIcon = React.createClass({
  mixins: [IconMixin],

  renderSVG: function (size) {
    switch (size) {
    case 'small':
      return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M9 3.54l1.49-1.49c1.44-1.44 3.83-1.38 5.34 0.13l0 0c1.51 1.51 1.57 3.9 0.13 5.34l-2.98 2.98c-1.44 1.44-3.83 1.39-5.34-0.12l0 0"/><path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M9 14.47l-1.49 1.49c-1.44 1.44-3.83 1.39-5.34-0.12l0 0c-1.51-1.51-1.56-3.9-0.12-5.34l2.98-2.98c1.44-1.44 3.83-1.38 5.34 0.13l0 0"/>';
    case 'medium':
      return '<path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M16 5.75l2.79-2.79c2.7-2.7 7.18-2.6 10.01 0.23l0 0c2.83 2.83 2.93 7.31 0.23 10.01l-5.59 5.59c-2.7 2.7-7.18 2.6-10.01-0.23l0 0"/><path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M16 26.25l-2.79 2.79c-2.7 2.7-7.18 2.6-10.01-0.23l0 0c-2.83-2.83-2.93-7.31-0.23-10.01l5.59-5.59c2.7-2.7 7.18-2.6 10.01 0.23l0 0"/>';
    case 'large':
      return '<path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M24 8.63l4.19-4.19c4.05-4.05 10.78-3.89 15.02 0.35l0 0c4.24 4.24 4.4 10.97 0.35 15.02l-8.38 8.38c-4.05 4.05-10.78 3.89-15.02-0.35l0 0"/><path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M24 39.37l-4.19 4.19c-4.05 4.05-10.78 3.89-15.02-0.35l0 0c-4.24-4.24-4.4-10.97-0.35-15.02l8.38-8.38c4.05-4.05 10.78-3.89 15.02 0.35l0 0"/>';
    }
  }
});

module.exports = LinkIcon;


/** WEBPACK FOOTER **
 ** ./atoms/icons/Link.jsx
 **/